<template>
  <div id="personalservice">
    <div class="personalaccount_content">
      <div class="personalaccount_content_left">
        <div class="personalaccount_content_left_item">
          <div class="personalaccount_content_left_item_head">基础功能</div>
          <div class="personalaccount_content_left_item_content">
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/shopcarIndex">我的购物车</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalOrder" class>订单管理</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box select_box">
              <router-link to="/personalservice" class="select_box">售后申请</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personaCollection" class>我的收藏</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalHistory" class>浏览历史</router-link>
            </div>
          </div>
        </div>
        <div class="personalaccount_content_left_item">
          <div class="personalaccount_content_left_item_head">我的优惠信息</div>
          <div class="personalaccount_content_left_item_content">
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalPackage" class>我的红包</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalIntegral" class>我的积分</router-link>
            </div>
          </div>
        </div>
        <div class="personalaccount_content_left_item">
          <div class="personalaccount_content_left_item_head">发票管理</div>
          <div class="personalaccount_content_left_item_content">
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalTicket">申请开票</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="personalaccount_content_right">
        <div class="personalaccount_content_right_head1">
          <div class="personalaccount_content_right_head_left">订单号：{{odernumval}}</div>
          <div class="hands" @click="$router.back(-1)">返回</div>
        </div>
        <div class="personalaccount_content_right_box">
          <div
            class="personalaccount_content_right_head marb20"
            style="padding-top:0;margin-top:0;"
          >
            <div class="personalaccount_content_right_head_left">商品列表</div>
          </div>

          <div class="personalaccount_content_right_content">
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              :header-cell-style="getRowClass"
              :cell-style="cellStyle"
            >
              <el-table-column label="商品信息" width="420">
                <template slot-scope="scope">
                  <div class="tabshopimgbox flex">
                    <img :src="http + scope.row.goods_image" alt class="tabshopimg" />
                    <div class="tabshoptxt txtnowarp2">{{scope.row.goods_name}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="goods_spec_value" label="属性"></el-table-column>
              <el-table-column label="本店价">
                <template slot-scope="scope">
                  <div class="tabshopimgbox">{{scope.row.price*1 | filterA}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="number" label="购买数量"></el-table-column>
              <el-table-column label="小计">
                <template slot-scope="scope">
                  <div
                    class="tabshopimgbox c_red"
                  >{{scope.row.price*scope.row.number*scope.row.package | filterA}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="personalaccount_content_right_box">
          <div
            class="personalaccount_content_right_head marb20"
            style="padding-top:0;margin-top:0;"
          >
            <div class="personalaccount_content_right_head_left">售后服务列表</div>
          </div>
          <div class="personalaccount_content_right_content">
            <div class="content_item">
              <span style="font-size:16px;color: #d81023;line-height: 40px;">*</span>
              <span class="content_item_txt">服务类型：</span>
              <div class="personalaccount_content_right_content_item_lable">
                <input id="item1" type="radio" name="item" value="1" v-model="activeavl" />
                <label for="item1"></label>
                <span>退货退款</span>
              </div>
              <div class="personalaccount_content_right_content_item_lable">
                <input id="item2" type="radio" name="item" value="2" v-model="activeavl" />
                <label for="item2"></label>
                <span>换货</span>
              </div>
              <!-- <div class="personalaccount_content_right_content_item_lable">
                <input id="item3" type="radio" name="item" value="3" v-model="activeavl" />
                <label for="item3"></label>
                <span>维修</span>
              </div>-->
            </div>
            <div class="content_item">
              <span style="font-size:16px;color: #d81023;line-height: 40px;">*</span>
              <span class="content_item_txt">售后原因：</span>
              <!-- <select name class="content_item_select">
                <option value>	质量问题</option>
                <option value>商品与描述不符</option>

                <option value>其他</option>
              </select>-->
              <span class="content_item_select">
                <el-select v-model="value" placeholder="请选择">
                  <el-option
                    v-for="item in optionswhy"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </span>
            </div>
            <div class="content_item">
              <span style="font-size:16px;color: #d81023;line-height: 120px;">*</span>
              <span class="content_item_txt" style="line-height: 120px;">原因说明：</span>
              <textarea
                name
                rows
                cols
                class="content_item_text"
                placeholder="请填写原因"
                v-model="wantspeak"
              ></textarea>
            </div>
            <div class="content_item">
              <span style="font-size:16px;color: #d81023;line-height: 120px;">*</span>
              <span class="content_item_txt" style="line-height: 120px;">上传图片：</span>
              <div class="content_item_text1">
                <!-- <img
                  class="yinyezhizhao_item1_img"
                  src="../../../assets/img/personalhome/shizi.png"
                />
                <div class="yinyezhizhao_item1_txt">最多5张图片</div>
                <input
                  class="file_style"
                  type="file"
                  accept="image/*"
                  ref="file"
                  multiple="multiple"
                />-->
                <el-upload
                  action="1"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-success="successimg"
                  :on-error="errorimg"
                  :before-upload="beforupload"
                  :limit="3"
                  :on-exceed="exceeds"
                  :file-list="postimg"
                  :http-request="handleHttpRequest"
                  multiple
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </div>
            </div>
          </div>
        </div>
        <div class="personalaccount_content_right_box" v-show="activeavl=='2'">
          <div class="personalaccount_content_right_head flex" style="padding-top:0;margin-top:0;">
            <div class="personalaccount_content_right_head_left">收货地址</div>
            <div
              class="personalaccount_content_right_head_right"
              @click="jumpSp()"
              v-show="submitkey"
            >更换收货地址</div>
          </div>

          <div class="personalaccount_content_right_content">
            <div
              class="address_item"
              v-for="(item, index) in addressData"
              :key="index"
              @click="clickFn(item,index)"
              v-show="item.status == 1"
            >
              <div class="address_item_list flex">
                <div class="address_item_listleft">收货人：</div>
                <div class="address_item_listright txtnowarp">{{item.address_name}}</div>
              </div>
              <div class="address_item_list flex">
                <div class="address_item_listleft">收货地址：</div>
                <div class="address_item_listright txtnowarp">{{item.consignee}}{{item.address}}</div>
              </div>
              <div class="address_item_list flex">
                <div class="address_item_listleft">手机号码：</div>
                <div class="address_item_listright txtnowarp">{{item.mobile}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="submit_btn" @click="postcustomer" v-show="submitkey">提交</div>
        <div class="service_footer">
          <div class="service_footer_left">温馨提示：</div>
          <div class="service_footer_right">
            <div
              class="service_footer_right_item"
            >1、商品图片及信息仅供参考，不属质量问题；因拍摄灯光及不同显示器色差等问题可能造成商品图片与实物有色差，一切以实物为准；</div>
            <div class="service_footer_right_item">2、为不影响您的商品退换货服务，请妥善保管商品的附件、赠品、包装至少15天；</div>
            <div
              class="service_footer_right_item"
            >3、商品送货时您需与送货人员开箱验机（外观），开箱后如产品有外观缺陷附件问题的，可以直接拒收，签收后发生的外观损坏缺件等问题不予退换货；</div>
          </div>
        </div>
        <div class="rulebox" v-if="ruletab">
          <div class="ruleboxin">
            <div class="rule">
              <div class="ruletop">
                <span>新增收货地址</span>
                <img src="../../../../public/img/hideico1.png" alt class="_ico1" @click="rulebox" />
              </div>
              <div class="rulecount">
                <div class="personalaccount_content_right_content1">
                  <div class="personalaccount_content_right_content_item1">
                    <span class="personalaccount_content_right_content_item_txt1">收货人(必填)：</span>
                    <input
                      @input="inputFn1"
                      class="personalaccount_content_right_content_item_inp1"
                      type
                      name
                      id="consignee"
                      :value="localData1.consignee"
                    />
                  </div>
                  <div class="personalaccount_content_right_content_item1">
                    <span class="personalaccount_content_right_content_item_txt1">联系电话(必填)：</span>
                    <input
                      @input="inputFn1"
                      class="personalaccount_content_right_content_item_inp1"
                      type
                      name
                      id="mobile"
                      :value="localData1.mobile"
                    />
                  </div>
                  <div class="personalaccount_content_right_content_item1">
                    <span class="personalaccount_content_right_content_item_txt1">地址信息(必填)：</span>
                    <el-cascader
                      class="personalaccount_content_right_content_item_inp3"
                      style="resize:none;"
                      size="large"
                      :options="options1"
                      v-model="selectedOptions1"
                      @change="handleChange1"
                    ></el-cascader>
                  </div>
                  <div class="personalaccount_content_right_content_item1">
                    <span class="personalaccount_content_right_content_item_txt1">详细地址(必填)：</span>
                    <textarea
                      @input="inputFn1"
                      class="personalaccount_content_right_content_item_inp2"
                      id="address"
                      :value="localData1.address"
                      name
                      rows
                      cols
                    ></textarea>
                  </div>
                  <div class="personalaccount_content_right_content_item1">
                    <span class="personalaccount_content_right_content_item_txt1">设为默认：</span>
                    <div class="personalaccount_content_right_content_item_lable1">
                      <input
                        id="itemq"
                        type="radio"
                        name="itemq"
                        value="itemq"
                        :checked="checkedValue_z1"
                      />
                      <label for="itemq"></label>
                      <!--<span>男</span>-->
                      <!-- @click="onClick1" -->
                    </div>
                  </div>
                </div>
                <div class="personalaccount_content_right_content_btn1" @click="updateAddressFn">确定</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import DateSelect from "@/components/DateSelect";

import { regionData, CodeToText, TextToCode } from "element-china-area-data";

export default {
  name: "personalservice",
  components: {
    DateSelect
  },
  data() {
    return {
      fixedkey: false,
      tableData: [],
      addressData: [],
      optionswhy: [
        {
          value: "1",
          label: "发错货"
        },
        {
          value: "2",
          label: "商品损坏"
        },
        {
          value: "3",
          label: "不想要了"
        },
        {
          value: "4",
          label: "商品降价"
        },
        {
          value: "5",
          label: "大小/颜色/型号等不合适"
        },
        {
          value: "6",
          label: "商品与页面描述不符"
        },
        {
          value: "7",
          label: "缺少件"
        },
        {
          value: "8",
          label: "质量问题"
        },
        {
          value: "9",
          label: "其他"
        }
      ],
      value: "1",
      oder_shopid: 0,
      userid: 0,
      odernumval: "", //订单号
      shopdata: [],
      http: "",
      activeavl: 1,
      postimg: [], //上传图片
      dialogImageUrl: "",
      dialogVisible: false,
      postkey: true,
      fixedkey: false,
      tableData: [], //现有收获地址列表
      checkedValue_z: false, //是否默认
      checkedValue_z1: true, //是否默认
      localData: {}, //添加地址默认数据
      localData1: {}, //修改地址默认数据
      options: regionData,
      selectedOptions: [],
      options1: regionData,
      selectedOptions1: [],
      ruletab: false,
      sign: "",
      wantspeak: "",
      createdoder: [],
      mapid: "", //默认地址id
      submitkey: true
    };
  },
  filters: {
    //过滤器一：（使用时没有参数，即{{msg|filterA}}）
    filterA(value) {
      return "￥" + parseFloat(value.toFixed(2));
    },
    filterB(value) {
      return parseFloat(value.toFixed(2));
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    let that = this;
    console.log("用户信息");
    console.log(that.$storage.get("user_data"));
    if (that.$storage.get("user_data") != null) {
      that.userid = that.$storage.get("user_data").user_id;
      that.odernumval = that.$route.query.odernunmber;
      that.oder_shopid = that.$route.query.shopid;
    }
    that.http = that.$publicUrl.http1;
    that.getDingdan();
    that.selectAddressFn();
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= 300) {
        this.fixedkey = true;
      } else {
        this.fixedkey = false;
      }
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background: #eeeeee;font-size:18px;color:#333333;text-align:center;border-right:1px solid #eeeeee;font-weight:500";
      } else {
        return "";
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 5) {
        return "text-align:center;font-size:16px;color:#333333;";
      } else {
        return "text-align:center;font-size:16px;color:#333333;";
      }
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    getDingdan() {
      let that = this;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.getOrderSku,
        data: qs.stringify({
          user_id: that.userid,
          id: that.oder_shopid
        })
      })
        .then(function(response) {
          let data = response.data;
          if (data.stateCode == 10000) {
            let nweobj = new Object();
            nweobj.goods_image = data.data.goods_image;
            nweobj.goods_name = data.data.goods_name;
            nweobj.goods_spec_value = data.data.goods_spec_value;
            nweobj.price = data.data.price;
            nweobj.number = data.data.number;
            nweobj.package = data.data.package;
            let newarr = new Array();
            newarr.push(nweobj);
            that.tableData = newarr;
            console.log(data);
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取已有收货地址
    //查询收货地址
    selectAddressFn() {
      let that = this;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.addressselects,
        data: qs.stringify({ user_id: that.$storage.get("user_data").user_id })
      })
        .then(function(response) {
          //						console.log(response);
          let data = response.data;
          if (data.stateCode == 10000) {
            that.addressData = data.data;
            for (let i = 0; i < that.addressData.length; i++) {
              if (that.addressData[i].status == "1") {
                that.mapid = that.addressData[i].address_id;
              }
            }
            console.log(data);
          } else {
            that.$message({
              message: data.msg,
              type: "warning"
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    //修改收货地址
    rulebox() {
      let that = this;
      that.ruletab = !that.ruletab;
    },
    //获取值
    inputFn(event) {
      let that = this;
      that.localData[event.currentTarget.id] = event.currentTarget.value;
    },
    inputFn1(event) {
      let that = this;
      that.localData1[event.currentTarget.id] = event.currentTarget.value;
    },
    handleChange1(value) {
      let that = this;
      let arr = [];
      for (let i = 0; i < value.length; i++) {
        arr.push(CodeToText[value[i]]);
      }
      that.localData1["address_name"] = arr.join(",");
    },
    onClick() {
      // 支持单个单选框选中/取消相互切换，选中态与isChecked保持一致
      let that = this;
      that.checkedValue_z = !that.checkedValue_z;
      if (that.checkedValue_z == true) {
        that.localData["status"] = 1;
      } else {
        that.localData["status"] = 0;
      }
    },
    onClick1() {
      // 支持单个单选框选中/取消相互切换，选中态与isChecked保持一致
      let that = this;
      that.checkedValue_z1 = !that.checkedValue_z1;
      if (that.checkedValue_z1 == true) {
        that.localData1["status"] = 1;
      } else {
        that.localData1["status"] = 0;
      }
    },
    jumpSp(item) {
      let that = this;
      that.ruletab = !that.ruletab;
      that.selectedOptions1 = [];
    },
    //新增收货地址
    updateAddressFn() {
      let that = this;
      that.localData1["user_id"] = that.$storage.get("user_data").user_id;
      that.localData1["status"] = 1;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.addressinserts,
        data: qs.stringify(that.localData1)
      })
        .then(function(response) {
          //						console.log(response);
          let data = response.data;
          if (data.stateCode == 10000) {
            that.$message({
              message: "添加成功",
              type: "success"
            });
            that.localData1 = {};
            that.selectedOptions1 = [];
            that.checkedValue_z1 = false;
            that.selectAddressFn();
            that.rulebox();
          } else {
            that.$message({
              message: data.msg,
              type: "warning"
            });
            that.rulebox();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //切换选择地址
    clickFn(item, index) {
      let that = this;
      let arr = that.addressData;
      for (let i in arr) {
        arr[i]["status"] = 0;
      }
      arr[index]["status"] = 1;
    },
    //上传图片
    //删除图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
      let that = this;

      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.removecustomerimg,
        data: qs.stringify({
          id: parseInt(file.cid)
        })
      })
        .then(function(response) {
          let data = response.data;
          console.log(data);
          if (data.stateCode == 10000) {
            this.$message.error("删除成功");
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    successimg(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      console.log(this.filearr);

      if (response.code == "10000") {
        this.$message.error(response.msg);
      } else {
        this.$message.error(response.msg);
        this.filearr = [];
        this.dialogImageUrl = "";
      }
    },
    errorimg(err, file, fileList) {
      console.log(err);
      console.log(file);
      console.log(fileList);
    },
    beforupload(file) {
      let that = this;
      console.log(file)
      if (that.submitkey) {
        let image = new Image();
        let reader = new FileReader();
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error("图片选择失败，图片大小不能超过 2MB,请重新选择!");
          return false;
        }
      } else {
        this.$message.error("请勿重复上传");
        return false;
      }
    },
    exceeds() {
      this.$message.error("图片选择失败，最多可上传3张,请重新选择!");
      return false;
    },
    handleHttpRequest(req) {
      console.log(req.file);
      let that = this;
      let data = new FormData();
      data.append("file", req.file);
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.upcustomerimg,
        data: data
      })
        .then(function(response) {
          let data = response.data;
          if (data.stateCode == 10000) {
            let reader = new FileReader();
            reader.onload = e => {
              let imgFile = e.target.result;
              that.postimg.push({
                name: req.file.name,
                uid: req.file.uid,
                url: imgFile,
                cid: data.data
              });
            };
            reader.readAsDataURL(req.file);
          } else {
          }
        })
        .catch(function(error) {
          console.log("异常");
          console.log(error);
        });
    },
    postcustomer() {
      let that = this;
      let wantspeaks = that.wantspeak.replace(/\s+/g, "");
      if (wantspeaks == "") {
        this.$message.error("请填写原因说明");
      } else {
        that.createdoder["user_id"] = that.$storage.get("user_data").user_id;
        that.createdoder["order_sku_id"] = that.oder_shopid;
        that.createdoder["type"] = that.activeavl;
        that.createdoder["cause"] = that.value;
        that.createdoder["explain"] = wantspeaks;
        that.createdoder["address_id"] = that.mapid;
        let _hitimg = [];
        for (let i = 0; i < that.postimg.length; i++) {
          _hitimg.push(that.postimg[i].cid);
        }
        _hitimg = _hitimg.toString();
        that.createdoder["media"] = _hitimg;
        console.log(that.createdoder)
        axios({
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
          },
          url: that.$publicUrl.http1 + that.$publicUrl.createdcustomer,
          data: qs.stringify(that.createdoder)
        })
          .then(function(response) {
              console.log(response);

            let data = response.data;
            if (data.stateCode == 10000) {
              that.submitkey = false;
              that.$confirm("售后申请成功, 是否返回上一步?", "系统提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                })
                .then(() => {
                   that.$router.push({
        path: "/personalservice",
       
      });

                })
                .catch(() => {
                  that.submitkey = false;
                });
            } else {
               that.$message.error(response.data.message);
            }
          })
          .catch(function(error) {
            console.log("异常");
            console.log(error);
          });
      }
    }
  }
};
</script>

<style scoped="scoped">
#personalservice {
  width: 100%;
  background-color: #f6f6f6;
  padding-top: 20px;
  padding-bottom: 20px;
}

.personalaccount_content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
  align-items: self-start;
}

.personalaccount_content_left {
  width: 170px;
  text-align: center;
  background: #ffffff;
}

.personalaccount_content_left_item_head {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #dddddd;
  color: #333333;
  font-size: 18px;
  font-weight: 550;
}

.personalaccount_content_left_item_content {
  width: 100%;
}

.personalaccount_content_left_item_content_box {
  font-size: 16px;
  color: #333333;
  width: 100%;
  height: 40px;
  margin-top: 10px;
  line-height: 40px;
}

.select_box {
  background: #dc1e33;
  color: #ffffff;
}

.personalaccount_content_left_item_content_box span {
  color: #dc1e33;
}

.personalaccount_content_right {
  width: 1010px;
  margin-left: 20px;
}

.personalaccount_content_right_head1 {
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  background: #eeeeee;
  color: #333333;
  font-size: 18px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-bottom: 30px;
}

.personalaccount_content_right_head {
  height: 50px;
  line-height: 50px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  color: #000000;
  background: #ffffff;
  font-size: 18px;
  border-bottom: 2px solid #dc1e33;
  margin-top: 20px;
}

.personalaccount_content_right_content {
  width: 100%;
  margin: 0 auto;
  /*margin-top: 20px;*/
  /*background: #ffffff;*/
}

.table_th {
  background: #eeeeee;
  font-size: 18px;
  color: #333333;
  text-align: center;
  border-right: 1px solid #dddddd;
  font-weight: 500;
}

.personalaccount_content_right_footer {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px;
  height: 200px;
  background: #ffffff;
  margin-top: 20px;
}

.personalaccount_content_right_footer_left {
  height: calc(100% - 20px);
  line-height: 180px;
  color: #333333;
  font-size: 24px;
}

.personalaccount_content_right_footer_center {
  width: 410px;
  font-size: 16px;
  color: #333333;
  height: 180px;
  box-sizing: border-box;
  padding-top: 70px;
}

.personalaccount_content_right_footer_right_con {
  font-size: 16px;
  color: #333333;
  height: 35px;
  line-height: 35px;
}

.personalaccount_content_right_footer_right_con1 {
  display: inline-block;
  width: 100px;
  text-align: right;
}

.personalaccount_content_right_footer_right_con2 {
  color: #dc1e33;
}

.personalaccount_content_right_footer_right_con3 {
  font-size: 20px;
  color: #dc1e33;
}

.spListAll {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding-right: 20px;
  box-sizing: border-box;
  font-size: 16px;
  color: #dc1e33;
  text-align: right;
  border: 1px solid #eeeeee;
  border-top: none;
  background: #ffffff;
}

.address_item {
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 30px;
  cursor: pointer;
  padding-top: 30px;
}

.address_item_top {
  font-size: 16px;
  color: #333333;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.address_item_txt {
  font-size: 14px;
  color: #666666;
  margin-top: 10px;
}
.address_item_txt1 {
  font-size: 14px;
  color: #333333;
  margin-top: 10px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.address_item_txt1s {
  color: #d81023;
}
.address_item_list {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 15px;
}
.address_item_listleft {
  width: 80px;
}
.address_item_listright {
  width: calc(100% - 80px);
}
.peisong {
  width: 100%;
  height: 70px;
  text-align: center;
  font-size: 14px;
  color: #666666;
  display: flex;
  flex-wrap: nowrap;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-top: none;
}

.peisong_left {
  width: 700px;
}

.peisong_left_top {
  margin-top: 10px;
  font-size: 16px;
  color: #333333;
}

.peisong_right {
  width: calc((100% - 700px) / 2);
  border-left: 1px solid #eeeeee;
  height: 70px;
  line-height: 70px;
}

.zhifu_btn {
  font-size: 24px;
  color: #ffffff;
  width: 200px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  margin-top: 20px;
  background: #dc1e33;
}

.personalaccount_content_right_content_head_left_inp {
  width: 240px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  padding-left: 10px;
  border: 1px solid #dddddd;
  background: #ffffff;
}

.personalaccount_content_right_content_head_left_btn {
  width: 120px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #dddddd;
  box-shadow: 0 1px 3px #dddddd;
  text-align: center;
  background: white;
  margin-left: 30px;
  font-size: 16px;
  background: #dc1e33;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
}

.xinxi_top {
  margin-top: 20px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.xinxi_top_left {
  font-size: 16px;
  color: #333333;
  height: 40px;
  line-height: 40px;
}

.xinxi_top_left span {
  color: #dc1e33;
}

.xinxi_footer {
  font-size: 16px;
  color: #333333;
  height: 40px;
  line-height: 40px;
}

.xinxi_footer span {
  color: #666666;
}

.btn_footer {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.footer_btn {
  width: 160px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #ffffff;
  background: #dc1e33;
  border-radius: 5px;
  font-size: 24px;
  margin-top: 20px;
}

.wuliu_item {
  width: 100%;
  height: 160px;
  overflow: auto;
  background: #ffffff;
  padding: 10px;
  box-sizing: border-box;
}

.wuliu_item_top {
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  font-size: 14px;
  color: #666666;
  position: relative;
}

.wuliu_item_top_xian {
  width: 2px;
  height: 50px;
  background: #cccccc;
  margin-left: 20px;
  margin-right: 20px;
}

.wuliu_item_top_date {
  width: 80px;
  text-align: center;
}

.yuan {
  position: absolute;
  left: 97px;
  top: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #cccccc;
}

.personalaccount_content_right_content_item_lable {
  line-height: 30px;
  width: 120px;
  position: relative;
}

.personalaccount_content_right_content_item_lable span {
  display: inline-block;
  font-size: 16px;
  color: #333333;
  margin-left: 20px;
  line-height: 40px;
}

input[type="radio"] {
  width: 20px;
  height: 20px;
  opacity: 0;
  position: relative;
  top: 4px;
  left: 5px;
}

label {
  position: absolute;
  left: 5px;
  top: 9px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #666666;
  display: inline-block;
}
/*设置选中的input的样式*/
/* + 是兄弟选择器,获取选中后的label元素*/

input:checked + label {
  background-color: #dc1e33;
  border: 1px solid #dc1e33;
}

input:checked + label::after {
  position: absolute;
  content: "";
  width: 5px;
  height: 10px;
  top: 3px;
  left: 6px;
  border: 2px solid #fff;
  border-top: none;
  border-left: none;
  transform: rotate(45deg);
}

.content_item {
  display: flex;
  flex-wrap: nowrap;
  margin: 0 auto;
  margin-top: 20px;
}

.content_item_txt {
  font-size: 16px;
  color: #333333;
  line-height: 40px;
}

.content_item_txt1 {
  font-size: 16px;
  color: #d81023;
  line-height: 40px;
}

.content_item_select {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  /* border: 1px solid #cccccc; */
}

.content_item_text {
  width: calc(100% - 90px);
  height: 120px;
  box-sizing: border-box;
  padding: 10px;
}
.yinyezhizhao_item1_img {
  margin-right: 0px !important;
}
.content_item_text1 {
  width: calc(100% - 90px);
  box-sizing: border-box;
  padding: 10px;
}
.yinyezhizhao_item1 {
  width: 120px;
  height: 120px;
  border: 1px solid #dddddd;
  border-radius: 8px;
  text-align: center;
  position: relative;
  display: inline-block;
  margin-right: 30px;
  background: #ffffff;
}
.content_item_text1 >>> .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 120px;
}
.content_item_text1 >>> .el-upload-list--picture-card .el-upload-list__item {
  width: 120px !important;
  height: 120px !important;
  line-height: 120px;
}
.content_item_text1
  >>> .el-upload-list--picture-card
  .el-upload-list__item
  .el-upload-list__item-thumbnail {
  display: block;
  object-fit: scale-down;
}
.yinyezhizhao_item2 {
  width: 180px;
  height: 120px;
  border: 1px solid #dddddd;
  border-radius: 8px;
  text-align: center;
  position: relative;
  display: inline-block;
  margin-right: 30px;
}
.yinyezhizhao_item1_img {
  display: inline-block;
  margin-top: 20px;
}
.yinyezhizhao_item1_txt {
  color: #999999;
  font-size: 14px;
  margin-top: 15px;
}
.file_style {
  display: inline-block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.address_btn {
  width: 120px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #d81023;
  color: #d81023;
  background: #ffffff;
  border-radius: 5px;
  font-size: 16px;
  text-align: center;
  margin-top: 20px;
  margin-left: 30px;
}
.submit_btn {
  width: 140px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  margin: 20px auto;
  background: #d81023;
  font-size: 24px;
  color: #ffffff;
  border-radius: 5px;
}
.service_footer {
  width: 100%;
  padding: 20px 10px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: nowrap;
  background: #ffffff;
  margin: 30px auto;
  margin-top: 60px;
}
.service_footer_left {
  font-size: 18px;
  color: #d81023;
  width: 90px;
  text-align: right;
  line-height: 30px;
}
.service_footer_right {
  font-size: 16px;
  color: #666666;
  width: calc(100% - 90px);
  line-height: 30px;
}
.hands {
  cursor: pointer;
}
.personalaccount_content_right_box {
  width: 100%;
  padding: 20px;
  padding-top: 0;
  overflow: hidden;
  background-color: #ffffff;
  margin-bottom: 30px;
}
.marb20 {
  margin-bottom: 20px;
}
.tabshopimg {
  width: 60px;
  height: 60px;
  display: block;
  border: 1px solid #dddddd;
  margin-right: 20px;
}
.tabshoptxt {
  text-align: left;
}
.personalaccount_content_right_head_left {
  width: 750px;
}
.personalaccount_content_right_head_right {
  width: calc(100% - 750px);
  text-align: right;
  font-size: 16px;
  color: #d81023;
  cursor: pointer;
}
.rulebox {
  width: 100%;
  position: fixed;
  height: 100%;
  z-index: 10;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.ruleboxin {
  width: 100%;
  height: 100%;
  position: relative;
}
.rule {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 690px;
  height: 534px;
  background-color: #ffffff;
  border-radius: 10px;
  z-index: 100;
  transform: translate(-50%, -50%);
  -webkit-box-shadow: 0 1px 5px #ccc;
  box-shadow: 0 1px 5px #ccc;
  box-sizing: border-box;
  /*padding:0px 40px;*/
  /*padding-bottom: 20px;*/
}
.ruletop {
  width: 100%;
  height: 60px;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
  font-weight: 600;
  color: white;
  background: #d81023;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding-left: 20px;
  /*padding-right:20px;*/
}
.rulecount {
  width: 100%;
  /*height:70vh;*/
  overflow: scroll;
  overflow-x: scroll;
}
.rulecount::-webkit-scrollbar {
  display: none;
}
._ico1 {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 15px;
  right: 20px;
  display: block;
  cursor: pointer;
}
.personalaccount_content_right_content1 {
  width: 552px;
  margin: 0 auto;
  margin-top: 40px;
}

.personalaccount_content_right_content_item1 {
  width: 100%;
  margin-top: 20px;
  /*position: relative;*/
  display: flex;
  flex-wrap: nowrap;
}

.personalaccount_content_right_content_item_txt1 {
  width: 190px;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  color: #333333;
  font-size: 18px;
  text-align: right;
}

input {
  outline: none;
  border: 0;
}

.personalaccount_content_right_content_item_inp {
  border: 1px solid #dddddd;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  width: calc(100% - 220px);
  box-sizing: border-box;
  padding-left: 20px;
  font-size: 16px;
  color: #666666;
  border-radius: 5px;
}

.personalaccount_content_right_content_item_inp1 {
  border: 1px solid #dddddd;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  width: calc(100% - 120px);
  box-sizing: border-box;
  padding-left: 20px;
  font-size: 16px;
  color: #666666;
  border-radius: 5px;
}
.personalaccount_content_right_content_item_inp3 {
  /*border: 1px solid #dddddd;*/
  display: inline-block;
  height: 40px;
  line-height: 40px;
  width: calc(100% - 120px);
  box-sizing: border-box;
  /*padding-left: 20px;*/
  font-size: 16px;
  color: #666666;
  border-radius: 5px;
}

.personalaccount_content_right_content_item_inp2 {
  border: 1px solid #dddddd;
  display: inline-block;
  height: 100px;
  line-height: 30px;
  width: calc(100% - 120px);
  box-sizing: border-box;
  padding-left: 20px;
  font-size: 16px;
  color: #666666;
  border-radius: 5px;
}

.personalaccount_content_right_content_item_txt1 {
  /*border: 1px solid #dddddd;*/
  display: inline-block;
  height: 40px;
  line-height: 40px;
  width: calc(100% - 220px);
  box-sizing: border-box;
  /*padding-left: 20px;*/
  font-size: 16px;
  color: #666666;
  border-radius: 5px;
}

.personalaccount_content_right_content_item_txt2 {
  width: 100px;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  color: #333333;
  font-size: 18px;
  margin-left: 20px;
}

.personalaccount_content_right_content_item_btn1 {
  width: 100px;
  display: inline-block;
  text-align: center;
  height: 40px;
  line-height: 40px;
  color: #ffffff;
  background: #dc1e33;
  border-radius: 0 5px 5px 0;
  font-size: 18px;
  cursor: pointer;
}

.personalPhone_footer1 {
  width: 100%;
  box-sizing: border-box;
  padding-left: 100px;
}

.personalPhone_footer_head1 {
  font-size: 18px;
  color: #333333;
  margin-bottom: 20px;
}

.personalPhone_footer_txt1 {
  font-size: 16px;
  color: #666666;
  margin-bottom: 8px;
}

.personalaccount_content_right_content_btn {
  width: 160px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 60px auto;
  color: #ffffff;
  font-size: 24px;
  background: #dc1e33;
  border-radius: 5px;
  cursor: pointer;
}
.personalaccount_content_right_content_btn1 {
  width: 160px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 30px auto;
  color: #ffffff;
  font-size: 24px;
  background: #dc1e33;
  border-radius: 5px;
  cursor: pointer;
}
.personalaccount_content_right_content_item_lable1 {
  line-height: 30px;
  width: calc(100% - 120px);
  position: relative;
  /*margin-left: 20px;*/
}

.personalaccount_content_right_content_item_lable span {
  display: inline-block;
  font-size: 16px;
  color: #333333;
  margin-left: 20px;
  line-height: 40px;
}

input[type="radio"] {
  width: 20px;
  height: 20px;
  opacity: 0;
  position: relative;
  top: 4px;
  left: 5px;
}

label {
  position: absolute;
  left: 5px;
  top: 9px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #666666;
  display: inline-block;
}
/*设置选中的input的样式*/
/* + 是兄弟选择器,获取选中后的label元素*/

input:checked + label {
  background-color: #dc1e33;
  border: 1px solid #dc1e33;
}

input:checked + label::after {
  position: absolute;
  content: "";
  width: 5px;
  height: 10px;
  top: 3px;
  left: 6px;
  border: 2px solid #fff;
  border-top: none;
  border-left: none;
  transform: rotate(45deg);
}

.personalaccont_content_right_footer_head1 {
  font-size: 24px;
  color: #333333;
  width: 100%;
  box-sizing: border-box;
  padding-left: 20px;
  margin: 20px auto;
}
textarea {
  resize: none !important;
}

.address_item_top_left {
  width: 80px;
  text-align: right;
  height: 24px;
}
.address_item_top_right {
  width: calc(100% - 80px);
  height: 24px;
}
.address_item_active {
  border: 1px solid #dc1e33;
  box-shadow: 0 1px 6px #db1e34;
}
.tabshopimgbox {
  text-align: center;
}
</style>
